// extracted by mini-css-extract-plugin
export var compactFilters = "_fp-4";
export var detailImage = "_fp-1";
export var dropdownContainer = "_fp-2";
export var imageContainer = "_fp-0";
export var selectedCard = "_fp-3";